import { useEffect, useState } from 'react';

import { loadPrintLettersForClinic } from '@/services/printLetters';

import type { ResolvedPrintLetters } from '@/types/printLetter';

/**
 * Print letters for a clinic: its own `print-letters` record, or its parent account's when the
 * clinic has no record. A clinic record that is off stays off.
 * org-extras is called with plain fetch, like the clinic letter settings, so not RTK Query.
 */
export const usePrintLetters = (clinicId?: string | null, parentId?: string | null) => {
  const [printLetters, setPrintLetters] = useState<ResolvedPrintLetters | null>(null);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (!clinicId) {
      setPrintLetters(null);
      return;
    }
    let cancelled = false;
    setIsLoading(true);
    void loadPrintLettersForClinic(clinicId, parentId)
      .then((resolved) => {
        if (!cancelled) setPrintLetters(resolved);
      })
      .finally(() => {
        if (!cancelled) setIsLoading(false);
      });
    return () => {
      cancelled = true;
    };
  }, [clinicId, parentId]);

  return { printLetters, isLoading };
};

export default usePrintLetters;
